/* eslint-disable */
import { useLazyQuery } from "@apollo/react-hooks";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import { maybe } from "@saleor/misc";
import EmailTemplateDetailForm, {
  emailTemplateDetailFormData
} from "../../components/EmailTemplateDetailForm";
import {
  useEmailSettingUpdateMutation,
  useEmailSetDefaultTemplatesMutation
} from "@saleor/emailTemplate/mutations";
import {
  emailSendTest,
  useEmailSettingByIdQuery
} from "@saleor/emailTemplate/queries";
import {
  emailTemplateListPath,
  emailTemplateUrl,
  RotaryUrlDialog,
  RotaryUrlQueryParams
} from "@saleor/emailTemplate/urls";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import React from "react";
import { useIntl } from "react-intl";

interface RotaryDetailsProps {
  id: string;
  params: RotaryUrlQueryParams;
}

const RotaryDetails: React.FC<RotaryDetailsProps> = ({ id, params }) => {
  const navigate = useNavigator();
  const notify = useNotifier();

  const [openModal] = createDialogActionHandlers<
    RotaryUrlDialog,
    RotaryUrlQueryParams
  >(navigate, params => emailTemplateUrl(id, params), params);

  const { data, loading, refetch } = useEmailSettingByIdQuery({
    variables: {
      id
    }
  });

  const [
    emailSettingUpdate,
    emailSettingUpdateOpts
  ] = useEmailSettingUpdateMutation({
    onCompleted: data => {
      if (data.emailSettingUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: "update emailTemplate successfully"
        });
      }
      refetch();
    }
  });
  const [emailSetDefault] = useEmailSetDefaultTemplatesMutation({
    onCompleted: data => {
      if (data.emailSetDefaultTemplate.errors.length === 0) {
        notify({
          status: "success",
          text: "update emailTemplate successfully"
        });
      }
    }
  });

  const handleUpdate = async (data: emailTemplateDetailFormData) => {
    const input = {
      sendFrequency:
        data.name == "account_subscribed"
          ? data.sendFrequency
            ? 1
            : 0
          : data.sendFrequency,
      template: data.template, //表单文本数据
      subject: data.subject
    };
    const result = await emailSettingUpdate({
      variables: {
        id,
        input
      }
    });
    return result.data.emailSettingUpdate.errors;
  };

  const intl = useIntl();

  const [getEmailSendTest] = useLazyQuery(emailSendTest, {
    fetchPolicy: "no-cache",
    onCompleted: data => {
      if (data.emailTest == "邮件已发送,请查收并检验") {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Test message sent.",
            description: "snackbar text"
          })
        });
      } else {
        notify({
          status: "error",
          text: intl.formatMessage({
            defaultMessage: "No templates found.",
            description: "snackbar text"
          })
        });
      }
    }
  });

  function emailSendTestFunction(name: String) {
    getEmailSendTest({ variables: { emailName: String(name) } });
  }

  const handleEmailSetDefault = async () => {
    const result = await emailSetDefault({
      variables: {
        id
      }
    });
    return result.data.emailSetDefaultTemplate.errors;
  };

  return (
    <>
      <EmailTemplateDetailForm
        emailSettingData={maybe(() => data?.emailSettingById)}
        disabled={loading}
        errors={emailSettingUpdateOpts?.data?.emailSettingUpdate.errors || []}
        onBack={() => navigate(emailTemplateListPath)}
        onDelete={() => openModal("remove")}
        onSubmit={handleUpdate}
        onDefault={handleEmailSetDefault}
        onTest={emailSendTestFunction}
        onItemsAdd={() => openModal("add-value")}
        onValueDelete={id =>
          openModal("remove-value", {
            id
          })
        }
        onValueReorder={null}
        onValueUpdate={id =>
          openModal("edit-value", {
            id
          })
        }
        saveButtonBarState={"default"}
      />
    </>
  );
};

export default RotaryDetails;
